import React from 'react';
import SkeletonBase from '@/components/skeletonBase';

const CaseSkeleton = () => {
  return (
    <div className='d-flex flex-column gap-3 mx-md-5 mx-2 mt-3'>
      {/* Back Button Skeleton */}
      <SkeletonBase variant="text" width="150px" height="20px" />

      {/* Screen Header Skeleton */}
      <div className="mb-2 mt-2">
        <SkeletonBase variant="text" width="300px" height="36px" style={{ marginBottom: '10px' }} />
        <SkeletonBase variant="text" width="450px" height="18px" />
      </div>

      {/* Patient Summary Header Skeleton */}
      <div className="bg-white p-3" style={{ borderRadius: '8px', border: '1px solid #dee2e6', boxShadow: '0 1px 3px rgba(0,0,0,0.01)' }}>
        <div className="d-flex w-100 flex-wrap">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex-grow-1 px-4 py-2" style={i !== 3 ? { borderRight: '1px solid #dee2e6', minWidth: '150px' } : { minWidth: '150px' }}>
              <SkeletonBase variant="text" width="120px" height="12px" style={{ marginBottom: '12px' }} />
              <SkeletonBase variant="text" width="160px" height="24px" />
            </div>
          ))}
        </div>
      </div>

      {/* Classification Skeleton */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem' }} className="mt-2">
         {[1, 2, 3, 4].map(i => (
            <div key={i} className="d-flex gap-3 align-items-center bg-white p-4" style={{ borderRadius: '8px', border: '1px solid #dee2e6' }}>
               <SkeletonBase variant="rounded" width="48px" height="48px" style={{ borderRadius: '10px' }} />
               <div className="d-flex flex-column gap-2" style={{ flex: 1 }}>
                  <SkeletonBase variant="text" width="60%" height="12px" />
                  <SkeletonBase variant="text" width="80%" height="20px" />
               </div>
            </div>
         ))}
      </div>

      {/* Complaint Skeleton */}
      <div className="bg-white p-4 mt-2" style={{ borderRadius: '8px', border: '1px solid #dee2e6' }}>
         <div className="d-flex align-items-center gap-3 mb-4">
             <SkeletonBase variant="rounded" width="28px" height="28px" style={{ borderRadius: '4px' }} />
             <SkeletonBase variant="text" width="250px" height="20px" />
         </div>
         <SkeletonBase variant="rounded" width="100%" height="90px" style={{ borderRadius: '8px' }} />
      </div>

      {/* Biometric Skeleton */}
      <div className="bg-white p-4 mt-2" style={{ borderRadius: '8px', border: '1px solid #dee2e6' }}>
         <div className="d-flex align-items-center gap-3 mb-4">
             <SkeletonBase variant="rounded" width="28px" height="28px" style={{ borderRadius: '4px' }} />
             <SkeletonBase variant="text" width="280px" height="20px" />
         </div>
         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '1rem' }}>
             {[1,2,3,4,5,6,7,8].map(i => (
                 <div key={i} className="d-flex gap-3 align-items-center p-3" style={{ borderRadius: '8px', border: '1px solid #dee2e6', backgroundColor: '#fbfdfe' }}>
                    <SkeletonBase variant="rounded" width="32px" height="32px" style={{ borderRadius: '6px' }} />
                    <div className="d-flex flex-column gap-2" style={{ flex: 1 }}>
                        <SkeletonBase variant="text" width="50%" height="10px" />
                        <SkeletonBase variant="text" width="70%" height="16px" />
                    </div>
                 </div>
             ))}
         </div>
      </div>

      {/* Family / Docs Skeleton */}
      <div className="d-flex gap-4 mt-2 mb-5" style={{ flexWrap: 'wrap' }}>
         {/* Family */}
         <div className="bg-white p-4" style={{ borderRadius: '8px', border: '1px solid #dee2e6', flex: '1 1 350px' }}>
             <div className="d-flex align-items-center gap-3 mb-4">
                 <SkeletonBase variant="rounded" width="28px" height="28px" style={{ borderRadius: '4px' }} />
                 <SkeletonBase variant="text" width="180px" height="20px" />
             </div>
             {[1,2,3].map(i => (
                 <SkeletonBase key={i} variant="rounded" width="100%" height="52px" style={{ borderRadius: '6px', marginBottom: '12px' }} />
             ))}
         </div>
         {/* Docs */}
         <div className="bg-white p-4" style={{ borderRadius: '8px', border: '1px solid #dee2e6', flex: '2 1 500px' }}>
             <div className="d-flex align-items-center gap-3 mb-4">
                 <SkeletonBase variant="rounded" width="28px" height="28px" style={{ borderRadius: '4px' }} />
                 <SkeletonBase variant="text" width="260px" height="20px" />
             </div>
             <SkeletonBase variant="rounded" width="200px" height="36px" style={{ borderRadius: '6px', marginBottom: '24px' }} />
             <SkeletonBase variant="rounded" width="100%" height="250px" style={{ borderRadius: '8px' }} />
         </div>
      </div>
    </div>
  )
}

export default CaseSkeleton;